<template>
  <div>
    <b-form-textarea
        id="textarea"
        style="margin-top: 2%;margin-bottom: 2% "
        v-model="message"
        :placeholder="$t('Enter message...')"
        rows="3"
    ></b-form-textarea>

    <b-form-group style="margin-bottom:0rem" :label="$t('Group')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
      <b-form-select v-model="group_id" :options="optionsGroup" class="mb-3"/>
    </b-form-group>

    <b-form-group style="margin-bottom:0rem" label-align="right" :label="$t('Send to all customers')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-checkbox switch size="lg" v-model.number="isForGroup" value="1" unchecked-value="0"/>
    </b-form-group>

    <div v-if="groupUsers.length > 0 && !isForGroup">
      <table-manager @filterChanged="filterChanged" :options="options" @paginationChanged="paginationChanged"/>

      <basic-table
        v-if="groupUsers"
        :items="groupUsers"
        :fields="profilesFields"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        @RowSelected="RowSelected"
        v-model="totalRows"/>
      <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    </div>

    <modal-ok-cancel @save="sendMsg" @cancel="bvModal.hide('ModalName')" size="lg" :saveButtonLabel="$t('Send')"/>

  </div>

</template>

<script>

export default {
  data () {
    return {
      isForGroup: false,
      placeHolder: this.$i18n.t('Enter message...'),
      message: '',
      group_id: null,
      currentRowProfile: null,
      selectedUser: null,
      options: {
        isShowAddButton: false,
        isShowPerPageLabel: false
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      profilesFields: [
        {key: 'user_id', label: 'ID', sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true}
      ]
    }
  },
  methods: {
    RowSelected (item) {
      this.selectedUser = item
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    },
    sendMsg () {
      if (this.selectedUser) {
        this.$emit('sendMessage', {content: this.message, roomId: this.selectedUser.user_id})
        this.$emit('hideAddRoom')
      } else if (this.isForGroup) {
        this.$emit('sendMessage', {group_id: this.group_id, content: this.message, roomId: -1})
        this.$emit('hideAddRoom')
      } else {
        this.$root.$emit('makeToasts', 'danger', 'Select User or set send to all', 'Error')
      }
    }

  },
  watch: {
    group_id: function (val) {
      this.$store.dispatch('Users/GET_GROUP_USERS', val)
    }
  },
  computed: {
    groupUsers () {
      return this.$store.getters['Users/GROUP_USERS']
    },
    optionsGroup () {
      let tmp = []
      tmp.push({ value: 0,
        text: 'All(0)'})
      this.$store.getters['Users/GROUPS'].forEach(el => {
        if (el.group_id === 1) { return }
        tmp.push({ value: el.group_id,
          text: el.group_name + '(' + el.group_id + ')'})
      })

      return tmp
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_GROUPS', null)
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/users/support/searchUser.vue